import * as PwaScripts from "../../PWA/./PwaScripts.js";
import { Account_UserStatus_$reflection, Account_LoginResult_$reflection, Account_LoginData_$reflection, Account_LoginData } from "../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { errorString, Encoders, sendJson } from "../../../Bfs.Web.Portale/./Http.fs.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../fable_modules/Thoth.Json.10.4.1/./Encode.fs.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.7.0/Fetch.fs.js";
import { ofArray, empty, append, singleton } from "../../fable_modules/fable-library-js.4.19.0/List.js";
import { Auto_generateBoxedDecoderCached_Z6670B51 } from "../../fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { CaseStrategy } from "../../fable_modules/Thoth.Json.10.4.1/Types.fs.js";
import { fromString } from "../../../Bfs.Web.Portale/../Bfs.Web.Kundenportal/fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { int32ToString, comparePrimitives, uncurry2 } from "../../fable_modules/fable-library-js.4.19.0/Util.js";
import { request, postEmpty } from "../../../Bfs.Web.Portale/Http.fs.js";
import { keyValueList } from "../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { Model__get_CanSubmit, Model, Msg, Model_Init_6DFDD678 } from "./Types.fs.js";
import { Cmd_batch, Cmd_none } from "../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { add, ofSeq } from "../../fable_modules/fable-library-js.4.19.0/Map.js";
import { GlobalMessageBox_Errors_7F866359, GlobalMessageBox, GlobalMessageBoxButton, GlobalMessageBoxButtonType, GlobalMessageType, GlobalMsg, UserSession } from "../../../Bfs.Web.Portale/Types.fs.js";
import { update } from "../../../Bfs.Web.Portale/Validation.fs.js";
import { DOMAttr, DangerousHtml, HTMLAttr } from "../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import * as react from "react";
import { some } from "../../fable_modules/fable-library-js.4.19.0/Option.js";
import { webPrint } from "../../../Bfs.Web.Portale/Preview.fs.js";

export function Http_postLogin(name, password, otp, akzeptiert) {
    const body = new Account_LoginData(name, password, otp, akzeptiert, PwaScripts.isRunningAsPwa());
    const response = sendJson("/api/account/login", toString(0, Auto_generateBoxedEncoder_437914C6(Account_LoginData_$reflection(), undefined, undefined, undefined)(body)), singleton(new Types_RequestProperties(4, ["include"])), "POST");
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(Account_LoginResult_$reflection(), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_postLogoff() {
    return postEmpty("/api/account/logoff");
}

export function Http_checkLogin() {
    const response = fetch("/api/account/user", keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(Account_UserStatus_$reflection(), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function State_init(page, user, lastModel) {
    return [Model_Init_6DFDD678(page.fields[0]), singleton((dispatch) => {
        dispatch(new Msg(0, []));
    })];
}

export function State_update(msg, model) {
    let matchValue, msg_6, props, msg_2;
    switch (msg.tag) {
        case 1:
            return [model, request(Http_checkLogin, undefined, (Item) => (new Msg(2, [Item])))];
        case 2:
            if (msg.fields[0].tag === 1) {
                return [new Model(model.Name, model.Password, model.Otp, model.OtpRequired, false, model.Sending, model.ErrorMsg, model.WartungMsg, model.GotoAfterLogin), Cmd_none()];
            }
            else {
                const sessiondata = ofSeq([["UserId", msg.fields[0].fields[0].Id], ["FirstName", msg.fields[0].fields[0].FirstName], ["LastName", msg.fields[0].fields[0].LastName], ["SprinklrChatHash", msg.fields[0].fields[0].SprinklrChatHash], ["SprinklrAppId", msg.fields[0].fields[0].SprinklrAppId], ["IsChatVisible", msg.fields[0].fields[0].IsChatVisible ? "true" : "false"], ["BeratungsterminUrl", msg.fields[0].fields[0].BeratungsterminUrl]], {
                    Compare: comparePrimitives,
                });
                const usersession = new UserSession(msg.fields[0].fields[0].Name, msg.fields[0].fields[0].Email, msg.fields[0].fields[0].Roles, msg.fields[0].fields[0].IsNewCustomer, (matchValue = msg.fields[0].fields[0].Kundennummer, (matchValue == null) ? sessiondata : add("Kundennummer", int32ToString(matchValue), sessiondata)));
                return [model, singleton((dispatch_3) => {
                    dispatch_3(new Msg(10, [new GlobalMsg(0, [usersession, model.GotoAfterLogin])]));
                })];
            }
        case 3:
            return [new Model(update(model.Name, msg.fields[0]), model.Password, model.Otp, model.OtpRequired, model.Loading, model.Sending, model.ErrorMsg, model.WartungMsg, model.GotoAfterLogin), Cmd_none()];
        case 4:
            return [new Model(model.Name, update(model.Password, msg.fields[0]), model.Otp, model.OtpRequired, model.Loading, model.Sending, model.ErrorMsg, model.WartungMsg, model.GotoAfterLogin), Cmd_none()];
        case 5:
            return [new Model(model.Name, model.Password, update(model.Otp, msg.fields[0]), model.OtpRequired, model.Loading, model.Sending, model.ErrorMsg, model.WartungMsg, model.GotoAfterLogin), Cmd_none()];
        case 8:
            if (Model__get_CanSubmit(model)) {
                return [new Model(model.Name, model.Password, model.Otp, model.OtpRequired, model.Loading, true, model.ErrorMsg, model.WartungMsg, model.GotoAfterLogin), request((tupledArg) => Http_postLogin(tupledArg[0], tupledArg[1], tupledArg[2], tupledArg[3]), [model.Name.Value, model.Password.Value, model.Otp.Value, msg.fields[0]], (Item_1) => (new Msg(9, [Item_1])))];
            }
            else {
                return [model, Cmd_none()];
            }
        case 9:
            if (msg.fields[0].tag === 1) {
                return [new Model(model.Name, model.Password, model.Otp, model.OtpRequired, model.Loading, false, "Es ist ein Fehler aufgetreten.", model.WartungMsg, model.GotoAfterLogin), Cmd_none()];
            }
            else {
                switch (msg.fields[0].fields[0].tag) {
                    case 3:
                        return [new Model(model.Name, model.Password, model.Otp, false, model.Loading, false, model.ErrorMsg, model.WartungMsg, model.GotoAfterLogin), (msg_6 = (new Msg(10, [new GlobalMsg(3, [new GlobalMessageBox(new GlobalMessageType(1, []), "Nutzungsbedingungen", (props = [new HTMLAttr(65, ["content"]), new DOMAttr(0, [new DangerousHtml(msg.fields[0].fields[0].fields[0])])], react.createElement("div", keyValueList(props, 1))), ofArray([new GlobalMessageBoxButton(new GlobalMessageBoxButtonType(2, []), "Abbrechen", undefined, true), new GlobalMessageBoxButton(new GlobalMessageBoxButtonType(0, []), "Drucken", some(new Msg(7, [msg.fields[0].fields[0].fields[0]])), false), new GlobalMessageBoxButton(new GlobalMessageBoxButtonType(3, []), "Akzeptieren", some(new Msg(6, [])), true)]))])])), singleton((dispatch_5) => {
                            dispatch_5(msg_6);
                        }))];
                    case 1:
                        return [new Model(model.Name, model.Password, model.Otp, model.OtpRequired, model.Loading, false, "Anmeldung fehlgeschlagen! Benutzername oder Passwort ist nicht korrekt, Ihr Zugang ist für 5 Minuten gesperrt. Bitte probieren Sie es anschließend erneut.", model.WartungMsg, model.GotoAfterLogin), Cmd_none()];
                    case 5:
                        return [new Model(model.Name, model.Password, model.Otp, model.OtpRequired, model.Loading, false, !model.OtpRequired ? "Ungültige Benutzerkennung und/oder Passwort." : "Das Einmalpasswort ist falsch.", model.WartungMsg, model.GotoAfterLogin), Cmd_none()];
                    case 2:
                        return [new Model(model.Name, model.Password, model.Otp, true, model.Loading, false, undefined, model.WartungMsg, model.GotoAfterLogin), Cmd_none()];
                    case 4:
                        return [new Model(model.Name, model.Password, model.Otp, model.OtpRequired, model.Loading, false, model.ErrorMsg, msg.fields[0].fields[0].fields[0], model.GotoAfterLogin), Cmd_none()];
                    default:
                        return [model, singleton((dispatch_4) => {
                            dispatch_4(new Msg(1, []));
                        })];
                }
            }
        case 6:
            return [model, singleton((dispatch_6) => {
                dispatch_6(new Msg(8, [true]));
            })];
        case 7: {
            webPrint("BFS-Kundenportal Nutzungsbedingungen", msg.fields[0]);
            return [model, Cmd_none()];
        }
        case 10:
            return [model, Cmd_none()];
        default:
            return [model, (supportsES2015) ? singleton((dispatch) => {
                dispatch(new Msg(1, []));
            }) : Cmd_batch(ofArray([(msg_2 = (new Msg(10, [new GlobalMsg(3, [GlobalMessageBox_Errors_7F866359(ofArray(["Die von Ihnen verwendete Browser-Version wird nicht unterstützt.", "Um alle Funktionen des BFS Kundenportals nutzen zu können, aktualisieren Sie bitte auf eine neuere Browser-Version. Das BFS Kundenportal gewährleistet einen vollen Funktionsumfang ab den Versionen: Mozilla Firefox 54, Google Chrome 51, Safari 10, Opera 38"]))])])), singleton((dispatch_1) => {
                dispatch_1(msg_2);
            })), singleton((dispatch_2) => {
                dispatch_2(new Msg(1, []));
            })]))];
    }
}

//# sourceMappingURL=State.fs.js.map
